import { Table, Tag, message } from "antd";
import type { ColumnsType } from "antd/es/table/interface";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { deleteChildItem, getItemsById } from "../../../api/itemapi";
import EditButton from "../../UI/EditButton/editbutton";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import { Dispatch, useEffect, useState } from "react";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { ItemsType } from "../itemsType";
import { AddEditPackaging } from "./AddEditPackaging";
import { useParams } from "react-router";
import { AxiosResponse } from "axios";
import { getItemUnitDropdown } from "../../../api/itemUnit";
interface PackagingListProps {
  ItemPackagingMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      itemsId: string | undefined;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  paginatedItemPackaging: any;
  setPaginatedItemPackaging: Dispatch<any>;
  filter: any;
  search: any;
  ItemId: any;
  isItemPackagingLoading: boolean;
  category: any;
}

interface PackagingInterface {
  id: number;
  guid: string;
  name: string;
  barcode: string;
  value: string;
  description: string;
}
const PackagingList = ({
  ItemPackagingMutation,
  paginatedItemPackaging,
  setPaginatedItemPackaging,
  filter,
  search,
  ItemId,
  isItemPackagingLoading,
  category,
}: PackagingListProps) => {
  const [t] = useTranslation("common");
  const [, setError] = useState("");
  const { id } = useParams();
  const [openPackaging, setOpenPackaging] = useState(false);
  const [Packaging, setPackaging] = useState<ItemsType>();
  const [selectedPackaging, setSelectedPackaging] = useState<any>();
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();

  useEffect(() => {
    ItemPackagingMutation({
      itemsId: ItemId,
      q: search,
      isActive: filter,
    })
      .then((res) => {
        setPaginatedItemPackaging(res.data?.childrenItems);
      })
      .catch((error) => {
        // Handle error
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ItemPackagingMutation, filter, ItemId]);

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const deleteItemsPackingMutation = useMutation(
    "deleteChildItem",
    deleteChildItem,
    {
      onSuccess: () => {
        ItemPackagingMutation({
          itemsId: ItemId,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedItemPackaging(res.data?.childrenItems);
          message.success("Complete successfully");
        });
      },
      onError,
    }
  );

  const getPackagingMutation = useMutation("getItems", getItemsById);
  function fillPackaging(id: any) {
    getPackagingMutation.mutate(id, {
      onSuccess: (res) => {
        setPackaging(res.data);
        setOpenPackaging(true);
      },
    });
  }

  const DeleteWarehouse = (id: string | undefined, component: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(component);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteItemsPackingMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const [formatedItemUnit, setFormatedItemUnit] = useState<{}[]>();
  const { isLoading: loadingItemUnit } = useQuery(
    "ItemUnit",
    getItemUnitDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemUnit(
          res.data?.map((unit: any) => {
            return { value: unit.id, label: unit.name };
          })
        );
      },
    }
  );

  const columns: ColumnsType<PackagingInterface> = [
    {
      title: `${t("name")}`,
      dataIndex: "name",
      key: "name",
      width: "25rem",
      className: "table-header",
    },
    {
      title: `${t("barcode")}`,
      dataIndex: "barcode",
      key: "barcode",
      width: "9rem",
    },
    {
      title: `${t("value")}`,
      dataIndex: "unitValue",
      key: "unitValue",
      width: "6rem",
    },
    {
      title: `${t("description")}`,
      dataIndex: "description",
      key: "description",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      key: "isActive",
      width: "4rem",
      align: "center",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      align: "center",
      fixed: "right",
      width: "5rem",
      render: (record: any) => (
        <>
          <EditButton
            onClick={() => {
              fillPackaging(record.id);
              setSelectedPackaging(record.id);
            }}
          />
          <DeleteButton
            onClick={() => DeleteWarehouse(record?.id, record?.name)}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={paginatedItemPackaging}
        loading={isItemPackagingLoading}
        pagination={{ pageSize: 8 }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
      />
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      {openPackaging && Packaging && (
        <AddEditPackaging
          Packaging={Packaging}
          openPackaging={openPackaging}
          setOpenPackaging={setOpenPackaging}
          id={selectedPackaging}
          itemid={id}
          formatedItemUnit={formatedItemUnit}
          loadingItemUnit={loadingItemUnit}
          categoryId={category.category?.id}
          type={category.type?.id}
          setPaginatedItemPackaging={setPaginatedItemPackaging}
          ItemPackagingMutation={ItemPackagingMutation}
          search={search}
        />
      )}
    </>
  );
};

export default PackagingList;
